import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const ShirazWineHouse = {
  id: '89',
  name: 'Shiraz Wine House',
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Shiraz_Wine_House',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Shiraz_Wine_House',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.INFANTRY_BARRACKS_RECRUITMENT_TIME_BONUS,
      EffectAmount.asPerLevel([
        1.4, 1.4, 1.4, 1.4, 3.0, 3.0, 3.0, 3.0, 3.0, 3.0,
        3.0, 3.0, 3.0, 3.0, 7.0, 7.0, 7.0, 7.0, 7.0, 9.0,
        9.0, 9.0, 9.0, 9.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0,
        11.0, 11.0, 11.0, 11.0, 15.0, 15.0, 15.0, 15.0, 15.0, 17.0,
        17.0, 17.0, 17.0, 17.0, 19.0, 19.0, 19.0, 19.0, 19.0, 19.0,
        19.0, 19.0, 19.0, 19.0, 23.0, 23.0, 23.0, 23.0, 23.0, 25.0
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 2) {
            return 0;
          }
          if (level <= 7) {
            return 1;
          }
          if (level <= 12) {
            return 2;
          }
          if (level <= 17) {
            return 3;
          }
          if (level <= 22) {
            return 4;
          }
          if (level <= 27) {
            return 5;
          }
          if (level <= 32) {
            return 6;
          }
          if (level <= 37) {
            return 7;
          }
          if (level <= 42) {
            return 8;
          }
          if (level <= 47) {
            return 9;
          }
          if (level <= 52) {
            return 10;
          }
          if (level <= 57) {
            return 10;
          }
          return 11;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          6000,9000,12000,15000,18000,21000,24000,27000,30000,33000,36000,39000,42000,45000,48000,51000,54000,57000,60000,63000,66000,69000,72000,75000,78000,81000,84000,87000,90000,93000,96000,99000,102000,105000,108000,111000,114000,117000,120000,123000,126000,129000,132000,135000,138000,141000,144000,147000,150000,153000,156000,159000,162000,165000,168000,171000,174000,177000,180000,183000
        ],
        bronzeAge: [
          9000,15000,21000,27000,33000,39000,45000,51000,57000,63000,69000,75000,81000,87000,93000,99000,105000,111000,117000,123000,129000,135000,141000,147000,153000,159000,165000,171000,177000,183000,189000,195000,201000,207000,213000,219000,225000,231000,237000,243000,249000,255000,261000,267000,273000,279000,285000,291000,297000,303000,309000,315000,321000,327000,333000,339000,345000,351000,357000,363000
        ],
        minoanEra: [
          12000,21000,30000,39000,48000,57000,66000,75000,84000,93000,102000,111000,120000,129000,138000,147000,156000,165000,174000,183000,192000,201000,210000,219000,228000,237000,246000,255000,264000,273000,282000,291000,300000,309000,318000,327000,336000,345000,354000,363000,372000,381000,390000,399000,408000,417000,426000,435000,444000,453000,462000,471000,480000,489000,498000,507000,516000,525000,534000,543000
        ],
        classicGreece: [
          15000,27000,39000,51000,63000,75000,87000,99000,111000,123000,135000,147000,159000,171000,183000,195000,207000,219000,231000,243000,255000,267000,279000,291000,303000,315000,327000,339000,351000,363000,375000,387000,399000,411000,423000,435000,447000,459000,471000,483000,495000,507000,519000,531000,543000,555000,567000,579000,591000,603000,615000,627000,639000,651000,663000,675000,687000,699000,711000,723000
        ],
        earlyRome: [
          18000,33000,48000,63000,78000,93000,108000,123000,138000,153000,168000,183000,198000,213000,228000,243000,258000,273000,288000,303000,318000,333000,348000,363000,378000,393000,408000,423000,438000,453000,468000,483000,498000,513000,528000,543000,558000,573000,588000,603000,618000,633000,648000,663000,678000,693000,708000,723000,738000,753000,768000,783000,798000,813000,828000,843000,858000,873000,888000,903000
        ],
        romanEmpire: [
          21000,39000,57000,75000,93000,111000,129000,147000,165000,183000,201000,219000,237000,255000,273000,291000,309000,327000,345000,363000,381000,399000,417000,435000,453000,471000,489000,507000,525000,543000,561000,579000,597000,615000,633000,651000,669000,687000,705000,723000,741000,759000,777000,795000,813000,831000,849000,867000,885000,903000,921000,939000,957000,975000,993000,1011000,1029000,1047000,1065000,1083000
        ],
        byzantineEra: [
          24000,45000,66000,87000,108000,129000,150000,171000,192000,213000,234000,255000,276000,297000,318000,339000,360000,381000,402000,423000,444000,465000,486000,507000,528000,549000,570000,591000,612000,633000,654000,675000,696000,717000,738000,759000,780000,801000,822000,843000,864000,885000,906000,927000,948000,969000,990000,1011000,1032000,1053000,1074000,1095000,1116000,1137000,1158000,1179000,1200000,1221000,1242000,1263000
        ],
        ageOfTheFranks: [
          27000,51000,75000,99000,123000,147000,171000,195000,219000,243000,267000,291000,315000,339000,363000,387000,411000,435000,459000,483000,507000,531000,555000,579000,603000,627000,651000,675000,699000,723000,747000,771000,795000,819000,843000,867000,891000,915000,939000,963000,987000,1011000,1035000,1059000,1083000,1107000,1131000,1155000,1179000,1203000,1227000,1251000,1275000,1299000,1323000,1347000,1371000,1395000,1419000,1443000
        ],
        feudalAge: [
          30000,57000,84000,111000,138000,165000,192000,219000,246000,273000,300000,327000,354000,381000,408000,435000,462000,489000,516000,543000,570000,597000,624000,651000,678000,705000,732000,759000,786000,813000,840000,867000,894000,921000,948000,975000,1002000,1029000,1056000,1083000,1110000,1137000,1164000,1191000,1218000,1245000,1272000,1299000,1326000,1353000,1380000,1407000,1434000,1461000,1488000,1515000,1542000,1569000,1596000,1623000
        ],
        iberianEra: [
          33000,63000,93000,123000,153000,183000,213000,243000,273000,303000,333000,363000,393000,423000,453000,483000,513000,543000,573000,603000,633000,663000,693000,723000,753000,783000,813000,843000,873000,903000,933000,963000,993000,1023000,1053000,1083000,1113000,1143000,1173000,1203000,1233000,1263000,1293000,1323000,1353000,1383000,1413000,1443000,1473000,1503000,1533000,1563000,1593000,1623000,1653000,1683000,1713000,1743000,1773000,1803000
        ],
        kingdomOfSicily: [
          36000,69000,102000,135000,168000,201000,234000,267000,300000,333000,366000,399000,432000,465000,498000,531000,564000,597000,630000,663000,696000,729000,762000,795000,828000,861000,894000,927000,960000,993000,1026000,1059000,1092000,1125000,1158000,1191000,1224000,1257000,1290000,1323000,1356000,1389000,1422000,1455000,1488000,1521000,1554000,1587000,1620000,1653000,1686000,1719000,1752000,1785000,1818000,1851000,1884000,1917000,1950000,1983000
        ],
        highMiddleAges: [
          39000,75000,111000,147000,183000,219000,255000,291000,327000,363000,399000,435000,471000,507000,543000,579000,615000,651000,687000,723000,759000,795000,831000,867000,903000,939000,975000,1011000,1047000,1083000,1119000,1155000,1191000,1227000,1263000,1299000,1335000,1371000,1407000,1443000,1479000,1515000,1551000,1587000,1623000,1659000,1695000,1731000,1767000,1803000,1839000,1875000,1911000,1947000,1983000,2019000,2055000,2091000,2127000,2163000
        ],
        earlyGothicEra: [
          42000,81000,120000,159000,198000,237000,276000,315000,354000,393000,432000,471000,510000,549000,588000,627000,666000,705000,744000,783000,822000,861000,900000,939000,978000,1017000,1056000,1095000,1134000,1173000,1212000,1251000,1290000,1329000,1368000,1407000,1446000,1485000,1524000,1563000,1602000,1641000,1680000,1719000,1758000,1797000,1836000,1875000,1914000,1953000,1992000,2031000,2070000,2109000,2148000,2187000,2226000,2265000,2304000,2343000
        ],
        lateGothicEra: [
          45000,87000,129000,171000,213000,255000,297000,339000,381000,423000,465000,507000,549000,591000,633000,675000,717000,759000,801000,843000,885000,927000,969000,1011000,1053000,1095000,1137000,1179000,1221000,1263000,1305000,1347000,1389000,1431000,1473000,1515000,1557000,1599000,1641000,1683000,1725000,1767000,1809000,1851000,1893000,1935000,1977000,2019000,2061000,2103000,2145000,2187000,2229000,2271000,2313000,2355000,2397000,2439000,2481000,2523000
        ],
      }).withOutput(ProductionOutputType.GOLD),
    ),
  ]),
};

export default ShirazWineHouse;
